// @flow
import React, { type Node } from 'react';

import PlainIcon, { iconTypes } from 'app/common/ui-next/plain-icon';


type Props ={
  videomeetLink: ?string
}

const VideomeetLink = ({ videomeetLink }: Props): Node => {
  if (!videomeetLink) {
    return null;
  }

  return (
    <a
      href={videomeetLink}
      target="_blank"
      rel="noopener noreferrer"
    >
      <PlainIcon
        type={iconTypes.VIDEO_CONFERENCE}
        width={20}
        height="auto"
      />
    </a>
  );
};

export default VideomeetLink;
